import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppHeader from "./core/components/layout/appHeader";
import AppInit from "./appInit";
import { IPages } from "./page/pages";
import { useAppState } from "./core/store/contextProvider";
import { ICore } from "./core/ICore";

const AppRouter = () => {
  const { pageState } = useAppState();

  return (
    <>
      <ICore.ILoadingBar isLoading={pageState?.isLoading} />
      <ICore.IAlertBox />
      <Router>
        <Routes>
          <Route path="/login" element={<IPages.Login />} />
          <Route path="/SystemError" element={<IPages.SystemError />} />
          <Route path="/Dashboard" element={<AppInit><AppHeader><IPages.Dashboard /></AppHeader></AppInit>} />
          <Route path="/Trading" element={<AppInit><AppHeader><IPages.Trading /></AppHeader></AppInit>} />
          <Route path="/MomentumTrading" element={<AppInit><AppHeader><IPages.MomentumTrading /></AppHeader></AppInit>} />
          <Route path="/SaleEngine" element={<AppInit><AppHeader><IPages.SaleEngine /></AppHeader></AppInit>} />
          <Route path="/LivePrediction" element={<AppInit><AppHeader><IPages.LivePrediction /></AppHeader></AppInit>} />
          <Route path="/Screening" element={<AppInit><AppHeader><IPages.Screening /></AppHeader></AppInit>} />
          <Route path="/BackTesting" element={<AppInit><AppHeader><IPages.BackTesting /></AppHeader></AppInit>} />
          <Route path="/ConfigureTrend" element={<AppInit><AppHeader><IPages.ConfigureTrend /></AppHeader></AppInit>} />
          <Route path="/ManagePaperTrade" element={<AppInit><AppHeader><IPages.ManagePaperTrade /></AppHeader></AppInit>} />
          <Route path="/" element={<AppInit><AppHeader><IPages.Dashboard /></AppHeader></AppInit>} />
          <Route path="*" element={<AppInit><AppHeader><IPages.Dashboard /></AppHeader></AppInit>} />
        </Routes>
      </Router>
    </>
  );
};

export default AppRouter;
